import React from 'react';
import { Box, Typography } from '@mui/material';
import CalendarFilter from '../../../components/common/calendar/CalendarFilter';
import PropTypes from 'prop-types';
import { useAuth } from '../../../contexts/AuthContext';

const TeamInsightsHeader = ({ onDateRangeChange, dateRange, teamName }) => {
    const { authState } = useAuth();
    const userName = authState?.user?.fullName || authState?.user?.name || 'Member';

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 2,
                mb: 3
            }}
        >
            <Typography variant="h6" component="h1" sx={{ fontSize: '18px', fontWeight: 600 }}>
                Welcome, {userName}
            </Typography>

            {onDateRangeChange && dateRange && (
                <CalendarFilter
                    onDateRangeChange={onDateRangeChange}
                    initialDateRange={dateRange}
                />
            )}
        </Box>
    );
};

TeamInsightsHeader.propTypes = {
    onDateRangeChange: PropTypes.func,
    dateRange: PropTypes.array,
    teamName: PropTypes.string
};

export default TeamInsightsHeader;
